import {
  NOTIFICATIONS_LIST,
  NOTIFICATIONS_LIST_SUCCESS,
  NOTIFICATIONS_LIST_ERROR,
  NOTIFICATIONS_NEW,
  NOTIFICATIONS_NEW_ERROR,
  NOTIFICATIONS_NEW_SUCCESS,
  NOTIFICATIONS_USER_LIST,
  NOTIFICATIONS_USER_LIST_ERROR,
  NOTIFICATIONS_USER_LIST_SUCCESS,
  NOTIFICATIONS_GROUP_LIST,
  NOTIFICATIONS_GROUP_LIST_SUCCESS,
  NOTIFICATIONS_GROUP_LIST_ERROR,
} from "./actionTypes"


export const notificationsList = data => ({
  type: NOTIFICATIONS_LIST,
  payload: data
});

export const notificationsListSuccess = data => ({
  type: NOTIFICATIONS_LIST_SUCCESS,
  payload: {data}
});

export const notificationsListError = error => ({
  type: NOTIFICATIONS_LIST_ERROR,
  payload: error,
});

export const notificationsNew = data => ({
  type: NOTIFICATIONS_NEW,
  payload: data
});

export const notificationsNewSuccess = data => ({
  type: NOTIFICATIONS_NEW_SUCCESS,
  payload: {data},
});

export const notificationsNewError = error => ({
  type: NOTIFICATIONS_NEW_ERROR,
  payload: error,
});

export const notificationsUserList = data => ({
  type: NOTIFICATIONS_USER_LIST,
  payload: data
});

export const notificationsUserListSuccess = data => ({
  type: NOTIFICATIONS_USER_LIST_SUCCESS,
  payload: {data},
});

export const notificationsUserListError = error => ({
  type: NOTIFICATIONS_USER_LIST_ERROR,
  payload: error,
});

export const notificationsGroupList = data => ({
  type: NOTIFICATIONS_GROUP_LIST,
  payload: data
});

export const notificationsGroupListSuccess = data => ({
  type: NOTIFICATIONS_GROUP_LIST_SUCCESS,
  payload: {data},
});

export const notificationsGroupListError = error => ({
  type: NOTIFICATIONS_GROUP_LIST_ERROR,
  payload: error,
});
